import React, { Suspense } from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
const HeroCarousel = React.lazy(() => import("../component3/HeroCarousel"));

export default function HomeHero(){
    const placeholder = <Box sx={{pl:3}}>
            ... Managing Technology for
            <br />
            <span style={{ color: "gold" }}>Sustainable</span> Development
        </Box>
    return<Stack direction="row" justifyContent="space-between" alignItems="flex-start"
    sx={{
        fontFamily:'roboto',
        backgroundColor: "rgba(128, 0, 0)",
        fontSize: 36,
        color: "white",
        p: 3,
        minHeight: 300,
        borderBottomRightRadius: 40,
        borderBottomLeftRadius: 40,
    }}
  >
  <Suspense fallback={placeholder}>
    <HeroCarousel/>
  </Suspense>
  {/* <Box style={{width: 0, height: 0, borderLeft: "20px solid rgba(255, 217, 0, 0.0676)", borderRight: "20px solid rgba(255, 217, 0, 0.0676)", borderBottom: "20px solid green"}}></Box> */}
  {/* <Box  animation="wave" sx={{mr:0,width:100, height:{xs:100,sm:100,md:200}, zIndex:200, borderTopLeftRadius:100, borderBottomLeftRadius:100, bgcolor:"rgba(255, 217, 0, 0.09976)"}}></Box> */}
  </Stack>
}